<div class="modal">
  <h1>{{ data()?.title }}</h1>
  <p>{{ data()?.subtitle }}</p>
  <p>{{ data()?.text }}</p>
</div>
